var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list_alt-24px",
    "data-name": "list alt-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29400",
    "data-name": "Path 29400",
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.05,6.82a4.27,4.27,0,0,1,4.27,4.27v3.73a4.27,4.27,0,0,1-8.54,0V11.09a4.27,4.27,0,0,1,4.27-4.27m0-2a6.29,6.29,0,0,0-6.27,6.27v3.73a6.27,6.27,0,0,0,12.54,0V11.09a6.29,6.29,0,0,0-6.27-6.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.21,
    y: 2.29,
    width: 2,
    height: 4.76,
    transform: "translate(-0.52 8.15) rotate(-46.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.46,
    y: 3.68,
    width: 4.76,
    height: 2,
    transform: "translate(1.12 12.17) rotate(-43.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.81,
    y: 7.7,
    width: 3.69,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.78,
    y: 9.9,
    width: 2.54,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.78,
    y: 13.98,
    width: 2.54,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.58,
    y: 7.7,
    width: 3.71,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.81,
    y: 16.17,
    width: 3.69,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.58,
    y: 16.17,
    width: 3.71,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.58,
    y: 11.95,
    width: 2.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.32,
    y: 11.95,
    width: 2.2,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.f395fe9f4f977cf6b711ce58b660482d.svg";
export { ForwardRef as ReactComponent };